import { twMerge } from "tailwind-merge";

type Props = {
  children: string;
  className?: string;
};

const CenteredCell = ({ children, className }: Props) => (
  <div className={twMerge("flex h-full min-h-10 items-center justify-center text-center", className)}>{children}</div>
);

export default CenteredCell;
